import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import Rating from 'react-rating';
export default class ratingDom extends Component {
	constructor(props) {
		super(props);
		this.state = {
      rating: 0,
    };
  }

  updateRating(value) {
		this.setState({ rating: value},()=>{
       this.props.submitRating(value);
    });
	}

  render() {
      return (
        <Rating emptySymbol={<ReactSVG path="/images/common/star.svg" wrapperClassName="svg-wrapper" style={{ width: '21px', height: '21px', marginRight:'7px'  }}/>}
        fullSymbol={<ReactSVG path="/images/common/star-selected.svg" wrapperClassName="svg-wrapper selected" style={{ width: '21px', height: '21px', marginRight:'7px' }}/>}
        onChange={ (rate) => {this.updateRating(rate)} } initialRating={ this.state.rating } />
      )
  }
}    


// WEBPACK FOOTER //
// ./src/components/review/ratingDom.js